import React, { useEffect, useState } from "react";
import "components/Layout/style.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TransectionImg from "assets/img/img6.svg";
import { Space } from "antd";
import TextField from "@mui/material/TextField";
import WelcomeLayout from "pages/Shared/WelcomeLayout";
import CFATextfield from "components/Ui/CFATextfield";
import Dropdown from "components/Ui/Dropdown";
import { useFormik } from "formik";
import { stockAmountValidation, validation } from "helpers/Schema";
import { useStore } from "_Store";
import { useContext } from "react";
import { Store } from "components/Ui";
import selectOption from "assets/mock/selectOption.json";

const TransactionStep2 = (props) => {
    const { state } = useStore();
    const {
        state: {
            activeFarm,
            activeCampaign,
            tableDataResponse
        }
    } = useContext(Store);
    const [saveAndContinue, setSaveAndContinue] = useState(false);
    const [entriesOption, setEntriesOption] = useState([]);
    const [exitsOption, setExitsOption] = useState([]);
    const [selectedSeed, setSelectedSeed] = useState({});
    const [seedPrice, setSeedPricing] = useState({});

    useEffect(() => {
        const filterEntriesOption = selectOption.filter(
            (items) => items.inputs === "entries"
        );
        const filterExitsOption = selectOption.filter(
            (items) => items.inputs === "exits"
        );
        setEntriesOption(filterEntriesOption);
        setExitsOption(filterExitsOption);
        getSeedData();
        if(tableDataResponse.type ==="ENTRIES") 
        {
            formik.setFieldValue(
             `typeData.destination`,
              1
            )
        }
    }, []);

    useEffect(() => {
        if(tableDataResponse.productType==="phyto"){
            if(activeCampaign && activeCampaign.phytoProductRequirement && tableDataResponse.phytoProductId){
                for(const phyto of activeCampaign.phytoProductRequirement){
                     if(tableDataResponse.phytoProductId === phyto.id){
                         formik.setFieldValue('typeData.unitPrice', phyto.cost);
                         break;
                     }
                }
             }
        }else if(tableDataResponse.productType==="semence"){
            if(activeCampaign && activeCampaign.seedRequirement && tableDataResponse.seedVarietyId){
                for(const semence of activeCampaign.seedRequirement){
                     if(tableDataResponse.seedVarietyId === semence.id){
                         formik.setFieldValue('typeData.unitPrice', semence.cost);
                         break;
                     }
                }
             }
        }else if(tableDataResponse.productType==="intrant"){
            if(activeCampaign && activeCampaign.fertilizerRequirement && tableDataResponse.fertilizerId){
                for(const fertilizer of activeCampaign.fertilizerRequirement){
                     if(tableDataResponse.fertilizerId === fertilizer.id){
                         formik.setFieldValue('typeData.unitPrice', fertilizer.cost);
                         break;
                     }
                }
             }
        }else if(tableDataResponse.productType==="culture"){
            if(activeCampaign && activeCampaign.expectedProfit && tableDataResponse.seed){
                for(const profit of activeCampaign.expectedProfit){
                     if(tableDataResponse.seed === profit.productId){
                         formik.setFieldValue('typeData.unitPrice', profit.amount);
                         break;
                     }
                }
             }
        }
        
    }, [selectedSeed]);

    const formik = useFormik({
        initialValues: {
            type: state?.["tableDataResponse"]?.["type"] || "",
            typeData: state?.["tableDataResponse"]?.["typeData"] || {},
        },
        validationSchema: stockAmountValidation,
        onSubmit: (vals) => {
            vals.typeData.rising = vals.typeData.amount * vals.typeData.unitPrice;
            if(!vals.typeData.destination) vals.typeData.destination = 1;
            Object.keys(vals).forEach((key) => {
                if (vals[key] === null) {
                    delete obj[key];
                }
            });
            props.onSubmit(vals, saveAndContinue);
        },
    });

    function getSeedData(){
        let products = activeCampaign.productsYouGrow,
            data ={};
        if(products && products.length > 0){
           for(const product of products){
             let seed = product.seed;
             if(seed.id===tableDataResponse.seed) data=seed;
           }
         }
         setSelectedSeed(data);
       }

    return (
        <div>
            <Grid className="stepFormfields">
                <WelcomeLayout
                    title={"Informations sur la culture à stocker"}
                    containImg={TransectionImg}
                    content={"Fiche de Stock"}
                    task={"Pour un type d'opération de stockage que vous souhaitez enregistré, vous devez fournir toutes les informations relative à la mise à jour du stockage."}
                    handleSubmit={(save) => {
                        formik.handleSubmit();
                        setSaveAndContinue(save);
                    }}
                    buttonLabel={"Continuer"}
                    backToStartBtn={{
                        label: 'Précédent',
                        onClick: () => {
                          props.onBack();
                        }
                      }}
                >
                    <div>
                        <div className="questionPage">
                            <div className="transection-option" style={{ padding: "50px 0" }}>
                                <Grid
                                    className="cahiersheet-optionsheet"
                                    style={{ padding: "0 20px" }}
                                >
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                        <Space direction="vertical">
                                                <CFATextfield
                                                    onChange={formik.handleChange}
                                                    label="Quantité"
                                                    name="typeData.amount"
                                                    value={formik.values?.["typeData"]?.["amount"]}
                                                    error={formik.errors?.["typeData"]?.["amount"]}
                                                />
                                                <div className="bg-[#ededed] w-[60px] flex items-center justify-center cfa-text">
                                                    <h5>{selectedSeed.seedUnite}</h5>
                                                </div>
                                            </Space>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Space direction="vertical">
                                                <CFATextfield
                                                    onChange={formik.handleChange}
                                                    label="Prix sur le marché définis"
                                                    name="typeData.unitPrice"
                                                    disabled={true}
                                                    //mettre le prix unitaire du produit ici
                                                    value={formik.values?.["typeData"]?.["unitPrice"]}
                                                    error={formik.errors?.["typeData"]?.["unitPrice"]}
                                                />
                                                <div className="bg-[#ededed] w-[60px] flex items-center justify-center cfa-text">
                                                    <h5>CFA</h5>
                                                </div>
                                            </Space>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Space direction="vertical">
                                                <CFATextfield
                                                    onChange={formik.handleChange}
                                                    label="Montant"
                                                    name="typeData.rising"
                                                    value={
                                                        formik.values?.["typeData"]?.["unitPrice"] *
                                                        formik.values?.["typeData"]?.["amount"]
                                                    }
                                                    error={Boolean(
                                                        formik.errors?.["typeData"]?.["rising"]
                                                    )}
                                                />
                                                <div className="bg-[#ededed] w-[60px] flex items-center justify-center cfa-text">
                                                    <h5>CFA</h5>
                                                </div>
                                            </Space>
                                        </Grid>
                                        { tableDataResponse && tableDataResponse.type !== "ENTRIES" ?
                                        <Grid item xs={6}>
                                            <Box sx={{ minWidth: 80 }}>
                                                <Dropdown
                                                    value={formik.values?.["typeData"]?.["destination"]}
                                                    label="Destination"
                                                    name="typeData.destination"
                                                    handleChange={(e) =>
                                                        formik.setFieldValue(
                                                            `typeData.destination`,
                                                            e.target.value
                                                        )
                                                    }
                                                    options={entriesOption}
                                                    error={formik.errors?.["typeData"]?.["destination"]}
                                                />
                                            </Box>
                                        </Grid>
                                        : null    }
                                    </Grid>
                                            


                                </Grid>
                            </div>
                            {Boolean(formik.errors["type"]) && (
                                <p className="errorText">{formik.errors["type"]}</p>
                            )}
                        </div>
                    </div>
                </WelcomeLayout>
            </Grid>
        </div>
    );
};
export default TransactionStep2;
